import { Component, OnInit, ViewChild } from '@angular/core';
import { PracticeService } from 'src/app/services/practice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Practice } from 'src/app/models/practice';
import { NotificationService } from 'src/app/services/notification.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import {MatDialog} from '@angular/material/dialog';
import { AddProgrammeComponent } from 'src/app/components/modals/add-programme/add-programme.component';

@Component({
  selector: 'app-programmes',
  templateUrl: './programmes.component.html',
  styleUrls: ['./programmes.component.scss']
})
export class ProgrammesComponent implements OnInit {
  public practice: Practice;
  public practiceId;
  public loadedPractice:boolean=false;
  public datasource:MatTableDataSource<any>;
  public practiceProgrammes=[];
  displayedColumns: string[] = ['name', 'status', 'start_date', 'close_date'];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    private _practice: PracticeService,
    private _route: ActivatedRoute,
    private _notify: NotificationService,
    private dialog: MatDialog,
    private _router: Router
  ) {
    this.practiceId = this._route.snapshot.paramMap.get("practiceId");
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
      }
    );
  }

  public getPracticeProgrammes(){
    this._practice.getPracticeProgrammes(this.practiceId).subscribe(
      res=>{
        this.practiceProgrammes=res;
        this.datasource = new MatTableDataSource<any>(this.practiceProgrammes);
        this.datasource.paginator=this.paginator;
      }
    );
  }

  public addProgramme(){
    const dialogRef = this.dialog.open(AddProgrammeComponent, {
      width: '350px',
      data: {practice: this.practice},
      panelClass: 'ng-modal-custom'
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this._notify.showMessage('New programme created.', 'OK');
        this.getPracticeProgrammes();
      }
    });
  }

  public navigateToProgramme(row){
    this._router.navigate(['/practices/'+this.practiceId+'/programmes/'+row.id]);
  }

  ngOnInit() {
    this.getPractice();
    this.getPracticeProgrammes();
  }

}
